import PropertiesLayout from "./propertiesLayout";

export default PropertiesLayout;
